/**
 * Shared "one gesture, one history entry" bookkeeping for the SSR search URL.
 *
 * That URL is written from two independent places: the SearchParameterManager
 * (Coveo state) and the bare `pushState` behind the non-Coveo params, today
 * `hideOwnership`. A single gesture that changes both — the mobile drawer's
 * Clear all, which deselects every facet AND the ownership filter — would
 * otherwise leave two entries behind, the first of them an intermediate state
 * (ownership cleared, facets still applied) the user never saw and Back would
 * restore.
 *
 * So whichever side writes first claims the gesture's entry with a `push`, and
 * every later write of the same gesture refines it in place with a `replace`.
 * A write with no gesture behind it — a re-synchronize, a migrated legacy hash
 * — finds the count unchanged and refines too, so deep links don't accumulate
 * entries the user never navigated to.
 */
let gestureCount = 0;
let claimedGesture = 0;

export function countGesture(): void {
  gestureCount += 1;
}

export function claimGestureEntry(): void {
  claimedGesture = gestureCount;
}

export function isGestureEntryClaimed(): boolean {
  return claimedGesture === gestureCount;
}
